import React, { useState } from 'react';

import MuiTextField from '@material-ui/core/TextField';
import MuiBox from '@material-ui/core/Box';
import MuiButton from '@material-ui/core/Button';

function EditUPC({ upc, onSave, releaseId }) {
  const [formUPC, setFormUPC] = useState(upc);
  return (
    <MuiBox>
      <MuiTextField value={formUPC} onChange={({ target: { value } }) => setFormUPC(value)} />
      <MuiButton variant="contained" size="small" onClick={() => onSave({ releaseId, upc: formUPC })}>
        Save UPC
      </MuiButton>
    </MuiBox>
  );
}

export default EditUPC;
